import { __decorate } from "tslib";
import { NumberField } from '@microsoft/fast-foundation';
import { attr } from '@microsoft/fast-element';
import { ChameleonElementMixin } from '../common/ChameleonElement';
export class NumberFieldComponent extends ChameleonElementMixin(NumberField) {
    constructor() {
        super(...arguments);
        this.fieldsize = 'medium';
        this.success = false;
        this.error = false;
    }
    connectedCallback() {
        var _a, _b;
        super.connectedCallback();
        const helperText = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('[name="helpertext"]');
        if (!helperText) {
            const slot = document.createElement('slot');
            slot.name = 'helpertext';
            (_b = this.shadowRoot) === null || _b === void 0 ? void 0 : _b.appendChild(slot);
        }
    }
}
__decorate([
    attr
], NumberFieldComponent.prototype, "fieldsize", void 0);
__decorate([
    attr({ mode: 'boolean' })
], NumberFieldComponent.prototype, "success", void 0);
__decorate([
    attr({ mode: 'boolean' })
], NumberFieldComponent.prototype, "error", void 0);
